<template>
  <div id="jaked-landing-page">
    <div class="jaked-hero">
      <div class="jaked-hero-col">
        <img class="jaked-logo" src="static/tempAssets/logo-jkd-orizz.png" />
        <div class="jaked-wave-container">
          <img src="static/tempAssets/wave.svg" />
        </div>
        <h1>Benvenuto nella<br />Jaked Tribe</h1>
        <p>
          La nuova community per gli amanti dello sport.<br />
          <strong>Registrati e ottieni punti Goccia da subito!</strong>
        </p>
        <p class="button">
          <button @click="openIdp" class="button button-primary">
            entra nella tribe
          </button>
        </p>
      </div>
      <div class="jaked-hero-col"></div>
    </div>
    <section id="jaked-steps">
      <div class="header">
        <h3>Tuffati nella Jaked Tribe e accumula punti!</h3>
        <p>Semplice e divertente, scommettiamo?</p>
      </div>
      <div class="content">
        <div class="jaked-step box top">
          <img src="static/tempAssets/icon1.svg" />
          <p>
            <strong>Registrati e accedi</strong><br />al programma "Jaked Tribe"
          </p>
          <span class="number">1</span>
        </div>
        <div class="jaked-step line">
          <img src="static/tempAssets/path-2.png" />
        </div>
        <div class="jaked-step box bottom">
          <img src="static/tempAssets/icon2.svg" />
          <p>
            <strong>Completa le missioni</strong><br />per ottenere i tuoi primi
            punti
          </p>
          <span class="number">2</span>
        </div>
        <div class="jaked-step line inverse">
          <img src="static/tempAssets/path-2.png" />
        </div>
        <div class="jaked-step box top">
          <img src="static/tempAssets/icon3.svg" />
          <p>
            <strong>Accumula punti Goccia</strong><br />all'interno del tuo
            profilo
          </p>
          <span class="number">3</span>
        </div>
        <div class="jaked-step line">
          <img src="static/tempAssets/path-2.png" />
        </div>
        <div class="jaked-step box bottom">
          <img src="static/tempAssets/icon4.svg" />
          <p><strong>Scala la classifica e sfida</strong><br />la community</p>
          <span class="number">4</span>
        </div>
      </div>
    </section>
    <section id="jaked-info">
      <div class="jaked-col">
        <div class="jaked-wave-container">
          <img src="static/tempAssets/wave.svg" />
        </div>
        <h3>Ma cos'è Jaked Tribe?</h3>
        <p>
          È la nostra nuova community volta a valorizzare e premiare la tua
          fedeltà nei nostri confronti. In Jaked Tribe potrai giocare e compiere
          missioni, sfidando gli altri utenti e accumulando punti Goccia.
        </p>
        <p>
          <strong>Mettiti alla prova! Sei pronto a giocare con noi?</strong>
        </p>
      </div>
      <div class="jaked-col picture-02">
        <!--
        <img src="static/tempAssets/landing/picture-02.jpg" />
        -->
      </div>
    </section>
    <section id="jaked-registration">
      <div class="image-container picture-03 jaked-col">
        <!-- <img src="/static/tempAssets/landing/picture-03.jpg" /> -->
      </div>
      <div class="jaked-col">
        <div class="jaked-section-container">
          <div>
            <h3>
              Cosa aspetti? Entra nella Jaked Tribe,<br />gioca con noi e sfida
              la community!
            </h3>
          </div>
          <div>
            <button @click="scrollToTop()" class="button button-primary">
              entra nella tribe
            </button>
          </div>
        </div>
      </div>
    </section>

    <section id="jaked-mobile-app">
      <div class="jaked-col picture-03"></div>
      <div class="jaked-col">
        <div>
          <div class="jaked-wave-container">
            <img src="static/tempAssets/wave.svg" />
          </div>
          <h3>Jaked Tribe - Official App</h3>
          <p>
            Scarica la nuova App ufficiale di Jaked e immergiti nel nostro mondo
            direttamente dal tuo mdartphone: completa le sfide e accumula punti
            Goccia per conquistare i benefit pensati per te, conquistarli è
            veramente semplice. È sufficiente inserire le tue credenziali e
            completare tutte le nostre missioni.
          </p>
        </div>
        <div class="stores">
          <img
            class="qr-code"
            src="static/tempAssets/Jaked-tribe-link-to-store.gif"
          />
          <div class="apps">
            <a
              href="https://play.google.com/store/apps/details?id=com.jaked.app"
              target="_blank"
            >
              <img src="static/tempAssets/app-store-google.svg" />
            </a>
            <a
              href="https://apps.apple.com/us/app/jaked-tribe-official-app/id1659367989"
              target="_blank"
            >
              <img src="static/tempAssets/app-store-ios.svg" />
            </a>
          </div>
        </div>
      </div>

      <!--
  <div class="jaked-col stores">
    <div class="stores-container">
      <a
        href="https://play.google.com/store/apps/details?id=com.jaked.app"
        target="_blank"
      >
        <img src="static/tempAssets/app-store-google.svg" />
      </a>
      <a
        href="https://apps.apple.com/us/app/jaked-tribe-official-app/id1659367989"
        target="_blank"
      >
        <img src="static/tempAssets/app-store-ios.svg" />
      </a>
    </div>
  </div>
  -->
    </section>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import parseDomain from "parse-domain";
import _ from "lodash";
import iconGoogle from "../../assets/svg/google_G_logo.svg";
import { changeLocale, getLocale } from "@/i18n.js";

export default {
  data() {
    return {
      icons: {
        google: iconGoogle,
        garmin: "iconGarminConnect"
      },
      appleButton: "appleButton",
      homeData: {},
      login: {
        credential: "",
        password: ""
      },
      locale: getLocale(),
      locales: this.generateLocales(),
      localeOpen: false
    };
  },
  beforeCreate() {
    this.$http
      .get(
        "/api/v1/campaigns/" + this.$store.state.campaign.id + "/home/settings"
      )
      .then(response => {
        this.homeData = response.data.data;
      });
  },
  created() {
    const parsedDomain = parseDomain(window.location.hostname);
    if (this.$route.query.ref !== undefined) {
      Cookies.set("mgm", this.$route.query.ref, {
        expires: 1,
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
    }

    if (this.$route.query.mgm_code !== undefined) {
      Cookies.set("mgm_code", this.$route.query.mgm_code, {
        expires: 1,
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "mdooth" });
    },
    getSocialLoginLink(provider) {
      this.$http
        .get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            provider +
            "/socialLoginUrl"
        )
        .then(response => {
          const parsedDomain =
            parseDomain(window.location.hostname) || "localhost";
          if (response.data.data.url && parseDomain) {
            Cookies.set("fanize_social_fallback", window.location.hostname, {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            window.location = response.data.data.url;
          }
        });
    },
    async appleLogin() {
      const response = await this.$http.get(
        "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/users/apple/web/login"
      );
      const parsedDomain = parseDomain(window.location.hostname);
      Cookies.set("fanize_social_fallback", window.location.hostname, {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
      Cookies.set("fanize_apple_campaign_id", this.$store.state.campaign.id, {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
      Cookies.set("fanize_apple_state", _.get(response, "data.data.uuid"), {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });

      window.location = _.get(response, "data.data.url");
    },
    signin() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users/login",
          this.login
        )
        .then(response => {
          localStorage.setItem("token", response.data.data.token.access_token);
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;
          this.$store.commit("hideSpinner");
          this.$store.dispatch("getUserInfo").then(() => {
            this.pushDeviceInfo();
            this.$router.push({ name: "dashboard" });
          });
        })
        .catch(error => {
          let errorResponse = error.response;
          switch (errorResponse.status) {
            case 422:
            case 404:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Le credenziali non sono valide"),
                text: this.$i18n.t(
                  "Prova ad inserire nuovamente le credenziali Test corrette o segui la procedura di recupero"
                )
              });
              break;
            case 406:
              if (this.$store.state.brand.idm_external_verify) {
                this.$store.commit("pushMessage", {
                  type: "waiting",
                  title: this.$i18n.t("Aspetta!"),
                  text: this.$i18n.t(
                    "Controlla la tua mail per verificare il tuo account"
                  )
                });
              } else {
                this.currentDisplayIfNotDesktop = "confirmation";
                this.showConfirmation = true;
                this.confirmationUserId = errorResponse.data.meta.userId;
                this.confirmationType =
                  errorResponse.data.meta.confirmationType;
                this.confirmationAddress =
                  errorResponse.data.meta.confirmationAddress;
              }
              break;
            case 401:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Password non valida"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            default:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Error")
              });
          }
          this.$store.commit("hideSpinner");
        });
    },
    generateLocales() {
      const activeLocale = getLocale();
      this.locale = activeLocale;
      const locales = this.$store.state.campaign.accept_languages;
      return locales.filter(item => item != activeLocale);
    },
    async handleChangeLocale(locale) {
      this.locale = locale;
      const locales = this.$store.state.campaign.accept_languages;
      this.locales = locales.filter(item => item != locale);
      this.localeOpen = !this.localeOpen;
      await changeLocale(locale);
    },
    generateRandomInteger(low, high) {
      const lowCeil = Math.ceil(low);
      const highFloor = Math.floor(high);
      const randomFloat = lowCeil + Math.random() * (highFloor - lowCeil);

      return Math.floor(randomFloat);
    },
    openIdp() {
      /*
      $router.push({ name: 'access' })
       */
      window.open(this.loginLink, "_self");
    }
  },
  computed: {
    coverImage() {
      return this.$store.state.campaign.image;
    },
    loginLink() {
      const baseUrl = process.env.VUE_APP_IDP_BASE_URL || "";
      const clientId = process.env.VUE_APP_IDP_CLIENT_ID || "";
      const randomState = this.generateRandomInteger(1000000, 20000000);
      const redirectTo = process.env.VUE_APP_IDP_REDIRECT || "";

      const url = `${baseUrl}/signIn?client_id=${clientId}&state=${randomState}&redirect_uri=${redirectTo}&response_type=code`;
      console.log(url);
      return url;
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

$page-margin: 4vw;
$giallo: #f7fc00;
#jaked-landing-page {
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: white;

  .button {
    padding: 0.8rem 2rem;
    border-radius: 100px;
    text-align: center;
    cursor: pointer;
  }

  .button-primary {
    outline-color: var(--fe-primary);
    border: 1px solid var(--fe-base-inverted);
    background-color: var(--fe-base-inverted);
    color: var(--fe-base);
    transition: all 0.5s 0s ease-in-out;

    &:hover {
      outline-color: var(--fe-action-primary);
      border: 1px solid var(--fe-base-inverted);
      background-color: var(--fe-action-primary);
      color: var(--fe-base-inverted);
    }
  }

  h1 {
    font-size: 48px;
    line-height: 64px;
  }

  h3 {
    font-size: 36px;
    line-height: 48px;
  }

  p {
    font-size: 24px;
    line-height: 36px;
  }

  @include md {
    padding: 0 $page-margin;
  }

  .jaked-hero {
    order: 0;
    background: $giallo;
    padding: 2rem 1rem 0 1rem;
    @include md {
      padding-top: 0;
      margin: 0 $page-margin * -1 1rem $page-margin * -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .jaked-hero-col {
      @include md {
        padding: $page-margin $page-margin * 2;
      }

      img.jaked-logo {
        max-width: 100%;
        margin-bottom: $page-margin;
      }

      p.button {
        text-align: center;
        margin: 30% 0;

        button {
          // background: black;
          // color: white;
          text-transform: uppercase;
          // padding: 0 3rem;
          // border-radius: 1.5rem;
          white-space: nowrap;
        }
      }

      &:nth-child(2) {
        min-height: 100vw;
        margin: 0 -1rem 0 -1rem;
        @include md {
          min-height: 50vw;
        }
        background: url("/static/tempAssets/landing/picture-01.jpg") no-repeat
          top right;
        background-size: cover;
      }
    }
  }

  .pitcure-03 {
    background: url("/static/tempAssets/landing/picture-03.jpg") no-repeat top
      right;
    background-size: cover;
  }

  #jaked-steps {
    order: 1;
    padding: 1.5rem;
    @include md {
      padding-left: $page-margin;
    }

    .header {
      display: grid;
      justify-items: center;
    }

    .content {
      margin-top: 3rem;
      padding: 2rem 0;
      @include md {
        display: grid;
        //grid-template-columns: 22% 4% 22% 4% 22% 4% 22%;
        grid-template-columns: 5.5fr 1fr 5.5fr 1fr 5.5fr 1fr 5.5fr;
        column-gap: 0;
        width: 100%;
      }

      justify-items: center;

      .jaked-step {
        text-align: center;
        margin: 0 auto;
        width: 80vw;
        @include md {
          width: auto;
        }

        &.box {
          border: 1px solid #000000;
          border-radius: 1rem;
          display: grid;
          justify-items: center;
          padding: 15%;
          position: relative;
          height: 80vw;
          @include md {
            width: 100%;
            height: auto;
            aspect-ratio: 1;
            &.bottom {
              margin-top: 2rem;
            }
          }

          p {
            text-align: center;
            font-size: 18px;
            line-height: 24px;
          }

          span.number {
            text-align: center;
            line-height: 3rem;
            font-weight: bold;
            background: $giallo;
            width: 3rem;
            height: 3rem;
            border-radius: 1.5rem;
            position: absolute;
            left: -1.5rem;
            bottom: -1.5rem;
          }
        }

        &.line {
          height: 78px;
          @include md {
            width: 100%;
            height: auto;
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;
          }

          > img {
            transform: rotate(90deg);
            margin-top: 30px;
            @include md {
              width: 100%;
              transform: none;
              height: auto;
              position: relative;
              top: -2rem;
            }
          }

          &.inverse {
            > img {
              transform: rotate(270deg);
              @include md {
                transform: rotate(180deg);
                top: 0;
              }
            }
          }
        }
      }
    }
  }

  #jaked-info {
    order: 2;
    display: flex;
    flex-direction: column;
    background: white;
    @include lg {
      display: grid;
      grid-template-columns: 1fr auto;
      // margin-right: $page-margin * -1;
      padding-left: $page-margin / 2;
    }

    p {
      margin-bottom: 1.5rem;
    }

    .jaked-col {
      padding: 2rem;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      padding-right: 2rem;
      max-width: 1200px;
      @include md {
        display: block;
        min-height: 470px;
        > * {
          position: relative;
          z-index: 100;
        }
      }

      &:nth-child(2) {
        padding: 0;
        order: -1;
        @include lg {
          order: 0;
          z-index: 100;
        }
      }

      &.picture-02 {
        aspect-ratio: 1;
        background: url("/static/tempAssets/landing/picture-02.jpg") no-repeat
          top center;
        background-size: cover;
        max-height: 450px;
        justify-self: end;
      }

      .jaked-wave-container {
        img {
          width: auto;
        }
      }

      img {
        width: 100%;
        @include md {
          max-width: 50vw;
        }
      }
    }
  }

  section.image-container {
    order: 3;
    width: 100%;
    @include md {
      display: none;
    }

    img {
      width: 100%;
    }
  }

  #jaked-registration {
    order: 5;
    padding: 2rem;
    background: black;
    color: white;
    @include md {
      margin: 0 -3rem;
      padding: 3rem 5rem;
    }

    .jaked-section-container {
      text-align: center;
      @include md {
        display: grid;
        grid-template-columns: 70% 30%;
      }

      div {
        h3 {
          font-size: 24px;
          line-height: 28px;
          text-align: left;
          @include md {
            font-size: 36px;
            line-height: 48px;
          }
        }

        button {
          margin-top: 2rem;
          width: 300px;
          height: 50px;
          border-radius: 25px;
          background: $giallo;
          color: black;
          text-transform: uppercase;
          font-weight: bold;
        }
      }
    }
  }

  #jaked-mobile-app {
    order: 4;

    grid-template-columns: auto 1fr;
    align-items: center;
    margin-bottom: 4rem;

    @include lg {
      padding: 2rem;
      display: grid;
    }

    div.jaked-col {
      padding: 2rem;
      overflow: hidden;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      max-width: 1200px;
      @include md {
        display: flex;

        min-height: 470px;
        > * {
          position: relative;
          z-index: 100;
        }
      }

      &.picture-03 {
        aspect-ratio: 1;
        background: url("/static/tempAssets/landing/picture-03.jpg") no-repeat
          top center;
        background-size: cover;
        max-height: 450px;
        justify-self: end;
        width: 100%;
      }

      &:nth-child(2) {
        border-top: 1px solid #000000;
        padding-top: 3rem;
        @include md {
          justify-self: end;
        }
      }

      &:nth-child(1) {
        text-align: center;
        margin-top: 2rem;
        order: -1;
        @include lg {
          display: block;
          justify-self: start;
          max-height: 450px;
        }
      }

      .stores {
        display: flex;
        padding-top: 2rem;
        padding-bottom: 2rem;
        flex-direction: column;
        gap: 2rem;
        justify-content: center;
        width: 100%;
        align-items: center;

        .qr-code {
          display: none;
        }

        @include md {
          .qr-code {
            display: block;
          }
          flex-direction: row;
          justify-content: flex-start;
        }

        .apps {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
      }

      /*
            &:nth-child(3) {
              margin-top: 2rem;
              text-align: center;
              @include md {
                display: inline-block;
              }

              .stores-container {
                display: flex;
                flex-direction: column;

                a {
                  padding-bottom: 0.5rem;
                }

                @include md {
                  margin-left: 3rem;
                }
              }
            }
      */
    }
  }
}
</style>
